import React from "react";
import type { RecentBooksActivityEntity } from "../../../domain/entities/BooksHealthEntity";

export interface RecentActivitySectionProps {
  items?: RecentBooksActivityEntity[];
  loading?: boolean;
}

export function RecentActivitySection({
  items = [],
  loading = false,
}: RecentActivitySectionProps) {
  if (loading) {
    return (
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-lg border border-solid border-neutral-200 bg-white px-6 py-6 w-[60%]">
        <div className="h-4 w-64 animate-pulse rounded bg-neutral-200" />
        <div className="flex w-full flex-col items-start gap-0">
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              className="flex w-full items-start gap-4 border-b border-solid border-neutral-100 py-4"
            >
              <div className="h-4 w-12 flex-none animate-pulse rounded bg-neutral-100" />
              <div className="flex flex-1 flex-col gap-1">
                <div className="h-4 w-full animate-pulse rounded bg-neutral-100" />
                <div className="h-3 w-24 animate-pulse rounded bg-neutral-50" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-lg border border-solid border-neutral-200 bg-white px-6 py-6 w-[60%]">
      <span className="text-caption-bold font-caption-bold text-neutral-400 uppercase tracking-wider">
        RECENT ACTIVITY FROM YOUR TEAM
      </span>
      <div className="flex w-full flex-col items-start">
        {items.map((item, i) => (
          <div
            key={`${item.date}-${item.userName}-${i}`}
            className={
              i < items.length - 1
                ? "flex w-full items-start gap-4 border-b border-solid border-neutral-100 py-4"
                : "flex w-full items-start gap-4 py-4"
            }
          >
            <span className="w-12 flex-none text-caption font-caption text-neutral-400">
              {item.date}
            </span>
            <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
              <span className="text-body font-body text-neutral-900">
                {item.description}
              </span>
              <span className="text-caption font-caption text-neutral-400">
                {item.userName}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
